import type { UseFormReset } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { ICreateAccount } from "src/Types/account.types";
import AccountForm from "./AccountForm";

interface Props {
	handleClose: () => void;
}

const CreateAccount = ({ handleClose }: Props) => {
	const { mutate: createAccount, isPending } = useApiMutation<
		ICreateAccount,
		void
	>({
		method: "POST",
		endPoint: "/api/fair/admin/account",
		invalidateQueries: ["Accounts"],
	});

	const handleCreateAccount = (
		formData: ICreateAccount,
		reset: UseFormReset<ICreateAccount>
	) => {
		createAccount(formData);
		handleClose();
		reset();
	};

	return <AccountForm isLoading={isPending} onSubmit={handleCreateAccount} />;
};

export default CreateAccount;
